/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  standalone: true,
  name: 'translateWithFallback',
})
export class TranslateWithFallbackPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(key: string, fallback: string): string {
    const translation = this.translate.instant(key);
    return translation === key ? fallback : translation;
  }
}

